(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["poemia-newsletter-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const popup = document.getElementById('PoemiaNewsletterPopup');
    if (!popup) return;

    const storageKey = 'poemia-newsletter-popup-dismissed';
    const dismissedAt = Number(window.localStorage.getItem(storageKey));
    const fourteenDays = 14 * 24 * 60 * 60 * 1000;
    const showImmediately = Boolean(popup.querySelector('[data-poemia-popup-success], [role="alert"]'));

    if (!showImmediately && dismissedAt && Date.now() - dismissedAt < fourteenDays) return;

    const closePopup = () => {
      popup.classList.remove('is-visible');
      document.body.classList.remove('poemia-newsletter-popup-open');
      window.setTimeout(() => {
        popup.hidden = true;
        popup.setAttribute('aria-hidden', 'true');
      }, 350);
      window.localStorage.setItem(storageKey, String(Date.now()));
    };

    const openPopup = () => {
      popup.hidden = false;
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('poemia-newsletter-popup-open');
      window.requestAnimationFrame(() => popup.classList.add('is-visible'));
      popup.querySelector('.poemia-newsletter-popup__close')?.focus();
    };

    popup.querySelectorAll('[data-poemia-popup-close]').forEach((button) => {
      button.addEventListener('click', closePopup);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !popup.hidden) closePopup();
    });

    window.setTimeout(openPopup, showImmediately ? 0 : Number(popup.dataset.delay));
  })();
  } catch(e) { console.error(e); }
})();

})();
